// Smooth scroll-back used by stock-table pagination (Next/Prev).
//
// Why not window.scrollTo({behavior:'smooth'})? landing.css sets a
// GLOBAL `scroll-behavior: smooth`, so every per-frame scrollTo(0, y)
// was itself browser-animated — the two fighting animations produced
// the "zoom, pause, zoom" jerk. Each frame therefore scrolls with
// behavior:'instant' (overrides the CSS), while the rAF loop supplies
// the one continuous ease-in-out glide. The target is re-measured
// every frame so mid-scroll layout shifts (new rows landing) bend the
// path smoothly instead of snapping.
export function smoothScrollToEl(el, offset = 200, duration = 500) {
  if (!el) return;
  const startY = window.scrollY || window.pageYOffset;
  const firstTarget = Math.max(0, el.getBoundingClientRect().top + startY - offset);
  if (Math.abs(firstTarget - startY) < 4) return;
  const start = performance.now();
  // easeInOutQuad — gentle start AND gentle stop (no abrupt arrival).
  const ease = (t) => (t < 0.5 ? 2 * t * t : 1 - Math.pow(-2 * t + 2, 2) / 2);
  const step = (now) => {
    const p = Math.min(1, (now - start) / duration);
    const targetY = Math.max(0, el.getBoundingClientRect().top + (window.scrollY || window.pageYOffset) - offset);
    const y = startY + (targetY - startY) * ease(p);
    window.scrollTo({ top: y, left: 0, behavior: 'instant' });
    if (p < 1) requestAnimationFrame(step);
  };
  requestAnimationFrame(step);
}
